var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.showServiceJupm && _vm.isRenderHeader)?_c('div',{staticClass:"service-jump"},[_c('tvu-service-jump-collect')],1):_vm._e(),(_vm.isRenderHeader)?_c('Header',{attrs:{"showCenter":false}}):_vm._e(),_c('div',{staticClass:"main"},[(_vm.isRenderHeader)?_c('Menu'):_vm._e(),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }